// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridClearBody = {
  poolId: string;
  gridId: string;
};

export type typeSquaresGridClearOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    grid: {
      gridId: string;
      gridState: "open" | "locked" | "live" | "final" | "void";
      publishStatus: "draft" | "published";
      hasNumbers: boolean;
    };
  };
};

export type typeSquaresGridClearOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridClearOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridClearOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridClearBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "gridId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridClear(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridClearBody);
  }

  return async function postSquaresGridClear(
    payload: typeSquaresGridClearBody,
  ): Promise<typeSquaresGridClearOutput200 | typeSquaresGridClearOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridClear" failed before calling the network. #aff1c6304e5c`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#aff1c6304e5c" },
        },
        data: null,
      } as typeSquaresGridClearOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-clear`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGridClearOutput200 | typeSquaresGridClearOutput400;
  };
}
